<script>
import LandLeaseService from "@/services/LandLeaseService";
import { EventBus } from "@/libraries/EventBus";
import VLeaseContractSection from "./VLeaseContractSection.vue";
import VLeaseDeviationsSection from "./VLeaseDeviationsSection.vue";
import VLeaseExpirationSection from "./VLeaseExpirationSection.vue";
import VLeaseDeadlinesSection from "./VLeaseDeadlinesSection.vue";
import VLeaseNotesSection from "./VLeaseNotesSection.vue";

export default {
    components: {
        VLeaseContractSection,
        VLeaseDeviationsSection,
        VLeaseExpirationSection,
        VLeaseDeadlinesSection,
        VLeaseNotesSection
    },
    props: {
        leaseId: {}
    },
    data() {
        return {
            loading: true,
            lease: null
        };
    },
    async created() {
        await this.fetchLease();
        EventBus.$on("land-lease-attachments-changed", this.refreshAttachments);
        EventBus.$on("land-lease-exceptions-changed", this.refreshExceptions);
        EventBus.$on("land-lease-deadlines-changed", this.refreshDeadlines);
    },
    beforeDestroy() {
        EventBus.$off(
            "land-lease-attachments-changed",
            this.refreshAttachments
        );
        EventBus.$off("land-lease-exceptions-changed", this.refreshExceptions);
        EventBus.$off("land-lease-deadlines-changed", this.refreshDeadlines);
    },
    watch: {
        leaseId() {
            this.fetchLease();
        }
    },
    methods: {
        async fetchLease() {
            this.loading = true;
            try {
                const { data } = await LandLeaseService.GETS(this.leaseId);
                this.lease = data.data;
            } catch (e) {
                console.log("fetchLease e", e);
            }
            this.loading = false;
        },
        async refreshAttachments() {
            try {
                const { data } = await LandLeaseService.GETS(this.leaseId);
                this.$set(
                    this.lease,
                    "land_lease_attachments",
                    data.data.land_lease_attachments
                );
            } catch (e) {
                console.log("refreshAttachments e", e);
            }
        },
        async refreshExceptions() {
            try {
                const { data } = await LandLeaseService.GETS(this.leaseId);
                this.$set(
                    this.lease,
                    "land_lease_exceptions",
                    data.data.land_lease_exceptions
                );
            } catch (e) {
                console.log("refreshExceptions e", e);
            }
        },
        async refreshDeadlines() {
            try {
                const { data } = await LandLeaseService.GETS(this.leaseId);
                this.$set(
                    this.lease,
                    "land_lease_deadlines",
                    data.data.land_lease_deadlines
                );
            } catch (e) {
                console.log("refreshDeadlines e", e);
            }
        }
    }
};
</script>

<template>
    <card>
        <v-loader :loading="loading" v-if="loading" />
        <template v-else-if="lease">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 class="mb-0">
                        {{ lease.lease_type_name }}
                    </h2>
                    <span class="text-muted" v-if="lease.party_name">
                        {{ lease.party_name }}
                    </span>
                    <span class="text-muted" v-if="lease.project">
                        | {{ lease.project.title }}
                    </span>
                    <span class="text-muted" v-if="lease.status_name">
                        | {{ lease.status_name }}
                    </span>
                </div>
                <div>
                    <base-button
                        type="secondary"
                        size="sm"
                        outline
                        @click="$emit('close')"
                    >
                        <i class="far fa-times"></i>
                    </base-button>
                    <base-button
                        type="primary"
                        size="sm"
                        @click="$emit('edit', lease)"
                    >
                        <i class="far fa-pencil"></i>
                        {{ $t("land_leases.edit") }}
                    </base-button>
                </div>
            </div>

            <div class="row land-leases-ctrl">
                <div class="col">
                    <div class="viewer-section">
                        <v-lease-contract-section :land_lease="lease" />
                    </div>
                </div>

                <div class="col">
                    <div class="viewer-section">
                        <v-lease-deviations-section :land_lease="lease" />
                    </div>
                </div>

                <div class="col">
                    <div class="viewer-section">
                        <v-lease-expiration-section :land_lease="lease" />
                    </div>
                </div>

                <div class="col">
                    <div class="viewer-section">
                        <v-lease-deadlines-section :land_lease="lease" />
                    </div>
                </div>

                <div class="col">
                    <div class="viewer-section">
                        <v-lease-notes-section :land_lease="lease" />
                    </div>
                </div>
            </div>
        </template>
    </card>
</template>

<style lang="scss">
.land-leases-ctrl {
    div.col {
    }

    .viewer-section {
        padding: 10px;
        height: 100%;
        border: 1px solid $gray-400;
        border-radius: 6px;
    }

    div.col:first-child,
    div.col:last-child {
        .viewer-section {
        }
    }
}
</style>
